
import {Vue, Component} from 'vue-property-decorator';
import {IModule} from "@/modules/user-management/user-management-int";
import store from "@/services/store";

interface PowerExternalFrame {
    id?: number;
    code?: string;
    name_en: string;
    name_kz: string;
    name_ru: string;
    description: string;
    src: string;
    region_instance_code: string;
    module_code: string;
    user_id?: string;
}

@Component({})
export default class PowerExternalFrames extends Vue {
    // Данные таблицы
    items: PowerExternalFrame[] = [];
    loading = false;

    // Пагинация
    currentPage = 1;
    perPage = 10;
    totalRows = 0;

    // Поиск
    searchQuery = '';
    filterModuleCode = '';
    filterRegionCode = '';

    // Модальное окно
    showModal = false;
    modalMode: 'create' | 'edit' = 'create';
    editingItem: PowerExternalFrame | null = null;
    // Модальное окно просмотра
    showViewModal = false;
    viewItem: PowerExternalFrame | null = null;

    // Форма
    form: PowerExternalFrame = {
        code: '',
        name_en: '',
        name_kz: '',
        name_ru: '',
        description: '',
        src: '',
        region_instance_code: '',
        module_code: '',
        user_id: ''
    };

    // Валидация формы для дизэйбла кнопки "Сохранить"
    get isFormValid(): boolean {
        if (!this.form.name_ru || !this.form.name_ru.trim()) return false;
        if (!this.form.name_kz || !this.form.name_kz.trim()) return false;
        if (!this.form.name_en || !this.form.name_en.trim()) return false;
        if (!this.form.description || !this.form.description.trim()) return false;

        const url = String(this.form.src || '').trim();
        if (!/^https?:\/\/.+/i.test(url)) return false;

        if (!this.form.region_instance_code || !String(this.form.region_instance_code).trim()) return false;
        if (!this.form.module_code || !String(this.form.module_code).trim()) return false;

        return true;
    }

    get is_valid_server(): boolean {
        return store.state._instanceCode=='99' || store.state._instanceCode==''
    }

    // Поля таблицы
    fields = [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'code', label: 'КОД', sortable: true},
        {key: 'name_ru', label: 'НАЗВАНИЕ (RU)', sortable: true},
        {key: 'name_kz', label: 'НАЗВАНИЕ (KZ)', sortable: true},
        {key: 'name_en', label: 'НАЗВАНИЕ (EN)', sortable: true},
        {key: 'module_code', label: 'МОДУЛЬ', sortable: true},
        {key: 'region_instance_code', label: 'РЕГИОН', sortable: true},
        {key: 'actions', label: 'ДЕЙСТВИЯ', sortable: false}
    ];

    mounted() {
        this.loadData();
        this.loadModules();
        this.loadRegions();
    }

    // Загрузка данных
    async loadData() {
        this.loading = true;
        try {
            const page = this.currentPage - 1;
            const params = new URLSearchParams({
                page: page.toString(),
                size: this.perPage.toString()
            });

            if (this.searchQuery) {
                params.append('search', this.searchQuery);
            }

            const moduleCode = String(this.filterModuleCode || '').trim();
            const regionCode = String(this.filterRegionCode || '').trim();

            if (moduleCode) {
                params.append('module_code', moduleCode);
            }

            if (regionCode) {
                params.append('region_instance_code', regionCode);
            }

            if (this.filterModuleCode && this.filterModuleCode !== '') {
               params.append('module_code', String(this.filterModuleCode));
            }

            if (this.filterRegionCode && this.filterRegionCode !== '') {
                params.append('region_instance_code', String(this.filterRegionCode));
            }

            const response = await fetch(`/api-py/power-external-frames?${params.toString()}`);

            if (response.ok) {
                const data = await response.json();
                this.items = [];
                this.items = (data.content || []).map((x: any) => ({
                    ...x,
                    id: x.id !== undefined && x.id !== null ? Number(x.id) : undefined
                }));
                this.totalRows = data.totalElements || 0;
                console.log('power-external-frames response:', data);
            } else {
                this.$bvToast.toast('Ошибка загрузки данных', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true
                });
            }
        } catch (error) {
            console.error('Error loading data:', error);
            this.$bvToast.toast('Ошибка при загрузке данных', {
                title: 'Ошибка',
                variant: 'danger',
                solid: true
            });
        } finally {
            this.loading = false;
        }
    }

    // Поиск с задержкой
    onSearchInput() {
        this.currentPage = 1;
        this.loadData();
    }

    onFilterChange() {
        this.currentPage = 1;
        this.loadData();
    }

    // Смена страницы
    onPageChange(page: number) {
        this.currentPage = page;
        this.loadData();
    }

    // Открыть модальное окно для создания
    openCreateModal() {
        this.modalMode = 'create';
        this.editingItem = null;
        this.form = {
            code: '',
            name_en: '',
            name_kz: '',
            name_ru: '',
            description: '',
            src: '',
            region_instance_code: '',
            module_code: '',
            user_id: this.$store.state.user.sub
        };
        this.showModal = true;
    }

    // Открыть модальное окно для редактирования
    openEditModal(item: PowerExternalFrame) {
        this.form.user_id = this.$store.state.user.sub;
        this.modalMode = 'edit';
        this.editingItem = item;
        this.form = {
            ...item,
            id: item.id ? Number(item.id) : undefined,
            user_id: this.$store.state.user.sub
        };
        this.showModal = true;
    }

    // Открыть модальное окно для просмотра (iframe)
    openViewModal(item: PowerExternalFrame) {
        this.viewItem = item;
        this.showViewModal = true;
    }


    // Сохранить (создать или обновить)
    async saveItem() {
        // минимальная валидация (без изменения структуры)
        const requiredFields: Array<keyof PowerExternalFrame> = [
            'name_ru',
            'name_kz',
            'name_en',
            'description',
            'src',
            'region_instance_code',
            'module_code'
        ];

        for (const key of requiredFields) {
            const value = (this.form[key] as any);
            if (!value || String(value).trim() === '') {
                this.$bvToast.toast('Заполните все обязательные поля', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true
                });
                return;
            }
        }

        const url = String(this.form.src).trim();
        if (!/^https?:\/\/.+/i.test(url)) {
            this.$bvToast.toast('URL должен начинаться с http:// или https://', {
                title: 'Ошибка',
                variant: 'danger',
                solid: true
            });
            return;
        }

        if (!/^\d+$/.test(String(this.form.region_instance_code).trim())) {
            this.$bvToast.toast('Поле "Код региона" должно содержать только цифры', {
                title: 'Ошибка',
                variant: 'danger',
                solid: true
            });
            return;
        }

        // module_code: цифры или цифры.цифры (может быть несколько групп через точку)
        const moduleCode = String(this.form.module_code).trim();
        if (!/^\d+(\.\d+)*$/.test(moduleCode)) {
            this.$bvToast.toast('Поле "Код модуля" должно быть в формате 005.008 или состоять только из цифр', {
                title: 'Ошибка',
                variant: 'danger',
                solid: true
            });
            return;
        }


        try {
            if (this.modalMode === 'create') {
                await this.createItem();
            } else {
                await this.updateItem();
            }
        } catch (error) {
            console.error('Error saving item:', error);
        }
    }

    // Создать новую запись
    async createItem() {
        try {
            const {code, ...payload} = this.form;
            payload.user_id = this.$store.state.user.sub;

            const response = await fetch('/api-py/power-external-frames', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                this.$bvToast.toast('Запись успешно создана', {
                    title: 'Успех',
                    variant: 'success',
                    solid: true
                });
                this.showModal = false;
                this.loadData();
            } else {
                let errorMessage = 'Ошибка при создании записи';
                try {
                    const error = await response.json();
                    errorMessage = error.detail || errorMessage;
                } catch (e) {
                    // если сервер вернул не json
                }

                this.$bvToast.toast(errorMessage, {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true
                });

            }
        } catch (error) {
            console.error('Error creating item:', error);
            this.$bvToast.toast('Ошибка при создании записи', {
                title: 'Ошибка',
                variant: 'danger',
                solid: true
            });
        }
    }

    // Обновить запись
    async updateItem() {
        if (!this.editingItem || !this.editingItem.id) return;

        try {
            const {code, ...payload} = this.form
            payload.user_id = this.$store.state.user.sub;

            const response = await fetch(`/api-py/power-external-frames/${this.editingItem.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                this.$bvToast.toast('Запись успешно обновлена', {
                    title: 'Успех',
                    variant: 'success',
                    solid: true
                });
                this.showModal = false;
                this.loadData();
            } else {
                const error = await response.json();
                this.$bvToast.toast(error.detail || 'Ошибка при обновлении записи', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true
                });
            }
        } catch (error) {
            console.error('Error updating item:', error);
            this.$bvToast.toast('Ошибка при обновлении записи', {
                title: 'Ошибка',
                variant: 'danger',
                solid: true
            });
        }
    }

    // Удалить запись
    async deleteItem(item: PowerExternalFrame) {
        if (!item.id) {
            this.$bvToast.toast('Невозможно удалить запись без ID', {
                title: 'Ошибка',
                variant: 'danger',
                solid: true
            });
            return;
        }

        const confirmed = await this.$bvModal.msgBoxConfirm(
            `Вы уверены, что хотите удалить запись "${item.name_ru}"?`,
            {
                title: 'Подтверждение удаления',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Удалить',
                cancelTitle: 'Отмена',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }
        );

        if (!confirmed) return;

        try {
            const response = await fetch(`/api-py/power-external-frames/${item.id}`, {
                method: 'DELETE'
            });

            if (response.ok) {
                this.$bvToast.toast('Запись успешно удалена', {
                    title: 'Успех',
                    variant: 'success',
                    solid: true
                });
                this.loadData();
            } else {
                this.$bvToast.toast('Ошибка при удалении записи', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true
                });
            }
        } catch (error) {
            console.error('Error deleting item:', error);
            this.$bvToast.toast('Ошибка при удалении записи', {
                title: 'Ошибка',
                variant: 'danger',
                solid: true
            });
        }
    }

    // Просмотр iframe
    viewFrame(item: PowerExternalFrame) {
        this.openViewModal(item);
    }

    private modulesBase: IModule[] = [];
    private modulesList: IModule[] = [];
    private regionsList: any[] = [];

    private async loadModules() {
        try {
            const response = await fetch("/api-py/sic-modules");
            this.modulesBase = (await response.json()) as IModule[];
            this.modulesList = [...this.modulesBase];
            this.modulesList.sort((a, b) => a.code > b.code ? 1 : -1);
        } catch (error) {
            this.$bvToast.toast('Ошибка загрузки модулей', {
                title: 'Ошибка',
                variant: 'danger',
                solid: true
            });
        }
    }
    private async loadRegions() {
        try {
            const response = await fetch("/api-py/dict-kato-stat/root-regions");
            const data = await response.json();

            const regions = Array.isArray(data) ? data : (data.content || []);

        this.regionsList = regions.map((r: any) => ({
            code: String(r.code_short),
            name_ru: r.name_ru
        }));

    } catch (error) {
        this.$bvToast.toast('Ошибка загрузки регионов', {
            title: 'Ошибка',
            variant: 'danger',
            solid: true
        });
    }
}

    // Опции для select модулей
    get moduleOptions() {
        return this.modulesList.map(m => ({
            value: String(m.code),
            text: `${m.code} - ${m.name_ru}`
        }));
    }

    // Опции для select регионов
    get regionOptions() {
        return this.regionsList.map(r => ({
            value: String(r.code),
            text: `${r.code} - ${r.name_ru}`
        }));
    }

}
